import { useDroppable } from '@dnd-kit/core';
import { TaskCard } from './TaskCard';
import { Task } from '@/hooks/useTasks';

interface TaskStatusColumnProps {
  status: {
    id: string;
    label: string;
    color: string;
  };
  tasks: Task[];
  onTaskClick?: (task: Task) => void;
}

export function TaskStatusColumn({ status, tasks, onTaskClick }: TaskStatusColumnProps) {
  const { setNodeRef } = useDroppable({
    id: status.id,
  });

  return (
    <div className="flex flex-col gap-2">
      <div className={`${status.color} rounded-lg px-3 py-2`}>
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-sm">{status.label}</h3>
          <span className="text-xs text-muted-foreground">{tasks.length}</span>
        </div>
      </div>
      
      <div
        ref={setNodeRef}
        className="flex flex-col gap-2 min-h-[200px] p-2 rounded-lg bg-muted/20"
      >
        {tasks.map(task => (
          <div key={task.id} onClick={() => onTaskClick?.(task)} className="cursor-pointer">
            <TaskCard task={task} />
          </div>
        ))}
      </div>
    </div>
  );
}
